import { uiRows } from './types-def.js';
/**
 * `web/documents` (1.I-3): the document page; its rows arrive by CS rounds. 1.UF's rows (DECISIONS
 * 234 ruling 1): the editor's visible controls for its key-only actions.
 */
export const DOCUMENTS_INTERACTIONS = uiRows([
    {
        id: 'editor.block.unwrap',
        module: 'web/documents',
        behavior: "The block menu's Unwrap entries unwrap a read-aloud box, callout, quote, secret or GM note as its key does",
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.handle.focus',
        module: 'web/documents',
        behavior: 'The handle and + stand beside the focused block without hovering',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.block.context-menu',
        module: 'web/documents',
        behavior: 'A right-click on a block opens the block menu for it',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.handle.shift-select',
        module: 'web/documents',
        behavior: 'Shift-click on a handle extends the block selection to that block',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.picker.create-type',
        module: 'web/documents',
        behavior: 'The @ create row\'s "Create as" button picks the new page\'s type',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.table.clear-cells',
        module: 'web/documents',
        behavior: 'Clear cells in the Table submenu empties the remembered cells as Backspace does',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.dialogue.add-delivery',
        module: 'web/documents',
        behavior: 'The "Add delivery" button opens a dialogue line\'s delivery field',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.inline-check.dialog',
        module: 'web/documents',
        behavior: 'The inline check dialog inserts a check from + and edits one on click',
        owner: '1.UF',
        since: 'exit-1a',
    },
    {
        id: 'editor.paste.plain-text',
        module: 'web/documents',
        behavior: 'The "Paste as plain text" chip after a rich paste gives the plain paste',
        owner: '1.UF',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=documents.js.map